import { render, staticRenderFns } from "./VueSlickCarousel.vue?vue&type=template&id=5d71317e&scoped=true&lang=pug&"
import script from "./VueSlickCarousel.vue?vue&type=script&lang=js&"
export * from "./VueSlickCarousel.vue?vue&type=script&lang=js&"
import style0 from "./VueSlickCarousel.vue?vue&type=style&index=0&id=5d71317e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71317e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d71317e')) {
      api.createRecord('5d71317e', component.options)
    } else {
      api.reload('5d71317e', component.options)
    }
    module.hot.accept("./VueSlickCarousel.vue?vue&type=template&id=5d71317e&scoped=true&lang=pug&", function () {
      api.rerender('5d71317e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/components/VueSlickCarousel.vue"
export default component.exports